import React, { useState } from 'react';
import { useAsync } from 'react-use';
import { node } from 'prop-types';
import { assert } from '@kallidus/common';
import PRE_AUTH_CONFIG_QUERY from './preAuthConfig.query.graphql';
import { useApolloClient } from '@apollo/client';
import { PRE_AUTH_CONFIG_CONTEXT } from './usePreAuthConfig';
import getIsSignUpSite from '@ApplicationWide/getIsSignUpSite';

const fetchPreAuthConfig = async (apolloClient) => {
  const preAuthConfigResponse = await apolloClient.query({
    query: PRE_AUTH_CONFIG_QUERY,
    fetchPolicy: 'no-cache',
  });
  return preAuthConfigResponse.data.preAuthConfig;
};

const PreAuthConfig = ({ children }) => {
  const apolloClient = useApolloClient();
  const [preAuthConfig, setPreAuthConfig] = useState();
  const isSignUpSite = getIsSignUpSite();
  const { loading, error: preAuthConfigError } = useAsync(async () => {
    if (!isSignUpSite) {
      const config = await fetchPreAuthConfig(apolloClient);
      setPreAuthConfig(config);
    }
  }, [apolloClient, isSignUpSite]);

  assert.ifError(preAuthConfigError);

  if (loading) return null;
  return <PRE_AUTH_CONFIG_CONTEXT.Provider value={preAuthConfig}>{children}</PRE_AUTH_CONFIG_CONTEXT.Provider>;
};

PreAuthConfig.propTypes = { children: node };
export default PreAuthConfig;
